import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { maybeRefreshSession } from "./api";
import { initLiveUpdates } from "./liveUpdate";
import { initResumeChecks } from "./resume";
import { applyThemeFromStorage } from "./theme";
import "./index.css";

// Apply the theme BEFORE React mounts - otherwise dark-preferring
// users see a flash of light-themed UI on every full page load.
applyThemeFromStorage();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);

// Native app: bevestig dat deze bundel boot (anders rolt de plugin
// terug) en kijk stil of er een nieuwere webbundel klaarstaat. No-op
// in een browser - daar is verversen genoeg. Ná render, zodat een
// kapotte update nooit de eerste paint blokkeert.
initLiveUpdates();

// Hervat-checks (web/PWA): thema opnieuw afleiden na een suspend
// (dark→light-wissel terwijl de app sliep) en bij lange afwezigheid
// stil herladen als er een nieuwe bundel staat. Zie resume.ts.
initResumeChecks();

// Rollende sessie: token ouder dan een dag -> stil omruilen voor een
// vers (90 dagen vanaf nu). Zie maybeRefreshSession in api.ts.
void maybeRefreshSession();
